module.exports = "/fonts/opensanslight.ttf";